// Transition: change target currency
// html price
// selected target currency !
// Data attribute: target currency !
// Data attribute: original price
// Data attribute: converted price
// AND target currency === base currency
// возвращаем оригинальные цены, если выбрана базовая валюта магазина - возвращаем original price,
// записываем его же в converted price и устанавливаем target currency
import { setElementState } from '../priceControls';

const matchState = (state) => {
  return (
    state.selectedTargetCurrency !== state.convertedCurrency &&
    state.selectedTargetCurrency === state.baseCurrency
  );
};

const handle = (priceElement, state, config) => {
  const newState = {
    ...state,
    convertedCurrency: state.selectedTargetCurrency,
    convertedPrice: state.originalPrice,
  };

  setElementState(priceElement, newState, config);
};

export default { matchState, handle, name: 'currencyReset' };
